export default "__VITE_ASSET__IaVK5StE__"